import React, { Suspense, useState, lazy } from 'react'
import { PushGADataLayer, pureKeys } from "../../utils/helpers"
import BaseContainer from "../BaseContainer"
import FooterContainer from './FooterContainer'
import FooterCols from "./FooterCols"
const Subscribe = lazy(() => import(/* webpackChunkName: "subscribe" */ './Subscribe'));

export default function Footer({ data }) {
  const [active, setActive] = useState(null)
  const handleToggle = (index) => {
    setActive((prevState) => prevState !== index ? index : null)
  };

  const handleSocialEvent = (title) => {
    PushGADataLayer('Social','Follow Up',title);
    PushGADataLayer('Navigations','Footer Navigation',title);
  }

  return (
    <footer className="bg-ek-grey-600 text-white lg:py-14">
      <BaseContainer>
        <FooterContainer className="lg:grid-cols-3">
          {data?.columns?.map((group, groupInd) => (
            groupInd <= 2 && (
              <FooterCols group={group} key={pureKeys(group.heading) + groupInd} groupInd={groupInd} handleToggle={handleToggle} active={active} setActive={setActive} />
            )
          )
          )}
        </FooterContainer>
        <FooterContainer className="lg:grid-cols-3">
          {data?.columns?.map((group, groupInd) => (
            groupInd >= 3 && (
              <FooterCols group={group} key={pureKeys(group.heading) + groupInd} groupInd={groupInd} handleToggle={handleToggle} active={active} setActive={setActive} />
            )
          )
          )}

          {
            data?.connect && (
              <aside className="my-5 lg:my-0">
                {data.connect.heading && <h4 className="mb-4 lg:mb-5">{data.connect.heading}</h4>}
                <div className="grid gap-y-3 text-sm">
                  {data.connect?.description}
                  <div className="grid gap-8 lg:gap-5 grid-flow-col justify-start">
                    {data.connect?.links.map((social, socialInd) => (
                      <a href={social.href} target={social.target} key={pureKeys(social.title) + socialInd} className="w-8 h-8 bg-black hover:bg-black/40 transition rounded-full grid justify-center items-center" onClick={() => handleSocialEvent(social.title)}>
                        {
                          social.icon && <img src={social.icon} alt={social.title} loading="lazy" />
                        }
                      </a>
                    ))}
                  </div>
                  {data.connect?.subscribe && (
                    <Suspense fallback={<div>Loading...</div>}>
                      <Subscribe subscribe={data.connect?.subscribe} />
                    </Suspense>
                  )}

                </div>
              </aside>
            )
          }
        </FooterContainer>
        <FooterContainer className="lg:grid-flow-col text-sm text-center">
          <div className="grid lg:grid-flow-col lg:justify-start lg:gap-8">
            {data?.staticLinks?.map((link, linkInd) => (
              <a href={link.href} target={link.target} key={pureKeys(link.title) + linkInd} className="text-sm lg:text-xs font-light hover:underline hover:underline-offset-2 py-3 lg:py-0" onClick={() => PushGADataLayer('Navigations','Footer Navigation',link.title)}>{link.title}</a>
            ))}
          </div>
          <div className="lg:text-right text-xs lg:text-sm font-light lg:font-normal py-4 lg:py-0">
            {data?.copyright}
          </div>
        </FooterContainer>

      </BaseContainer>

    </footer>
  )
}
